<template>
  <div class="home-projects-card-outer-box text-left" @click="() => showModal(prj.youtube_link)">
    <!-- <div class="best-category">
      <HomeProjectsCarouselBest />
    </div> -->
    <div class="home-projects-card ml-auto">
      <div class="project-thumbnail-box">
        <img class="project-thumbnail" :src="` https://avishkaar-users.s3.amazonaws.com/${prj.project_thumbnail}`" :alt="`Project Thumbnail: ${prj.project_title}`">
      </div>
      <div class="projects-data-box-outer">
        <!-- <div class="maker-star">
          <div class="maker-text text-right mt-2 mr-1">
            Maker of the <br /> Month
          </div>
          <MakerMonthStar />
        </div> -->
        <div class="project-data-box px-3 pt-3">
          <span class="project-title" :title="prj.project_title">
            {{ prj.project_title }}
          </span>
        </div>
        <hr style="margin-right: 21%; margin-left: 15px;" />
        <div class="profile-box px-3 mb-3">
          <img v-if="prj.profile_img && prj.profile_img !== '0'" class="profile-image" :src="prj.profile_img" :alt="`Photo of ${prj.user_name}`" loading="lazy" />
          <img v-else class="profile-image" src="https://images.avishkaar.cc/user-placeholder.png" :alt="`Default Photo of ${prj.user_name}`" loading="lazy" />
          <span class="ml-3" style="font-size: 12px;">
            <span style="color: #acacac;">By &nbsp;</span>
            <span>{{ prj.user_name }}</span>
          </span>
        </div>
      </div>
    </div>
    <b-modal ref="modal-prj" hide-header hide-footer>
      <div class="modal-box">
        <div class="p-3 text-center">
          <iframe width="100%" height="315" :src="`https://www.youtube.com/embed/${ytLink}`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <button @click="closeModal" class="close-button">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
// svg
// import HomeProjectsCarouselBest from "@/components/svg/HomeProjectsCarouselBest"
// import MakerMonthStar from "@/components/svg/MakerMonthStar"

export default {
  name: "HomeProjectsSection",
  props: ['prj'],
  // components: {
  //   HomeProjectsCarouselBest,
  //   MakerMonthStar,
  // },
  data() {
    return {
      ytLink: '',
    }
  },
  methods: {
    showModal(ytl) {
      this.ytLink = ytl.split('?v=')[1];
      this.$refs['modal-prj'].show();
    },
    closeModal() {
      this.$refs['modal-prj'].hide();
    }
  }
}
</script>
<style scoped>
  .home-projects-card-outer-box {
    width: 263px;
    position: relative;
    padding-left: 10px;
  }
  .home-projects-card-outer-box > .best-category {
    position: absolute;
    top: 10px;
    height: 80px;
  }
  /* .home-projects-card-outer-box > .best-category > svg {
    height: 80px;
  } */

  .home-projects-card {
    width: calc(100% - 9px);
    background-color: #fff;
  }
  .home-projects-card-outer-box, .home-projects-card {
    /* height: 258px; */
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
  }

  /* top image section */
  .home-projects-card > .project-thumbnail-box {
    height: 156px;
    overflow: hidden;
  }

  .home-projects-card > .project-thumbnail-box > .project-thumbnail {
    width: 100%;
  }

  /* bottom data section */
  .home-projects-card > .projects-data-box-outer {
    position: relative;
    width: 100%;
  }

  .home-projects-card > .projects-data-box-outer > .maker-star {
    position: absolute;
    top: 0;
    right: 10px;
    /* width: 35%; */

    display: flex;
    /* justify-content: center;
    align-items: baseline; */
  }
  .home-projects-card > .projects-data-box-outer > .maker-star > .maker-text {
    font-size: 12px;
    font-weight: 700;
    color: #fcac31;
  }

  .home-projects-card > .projects-data-box-outer > .project-data-box {
    width: 50%;
    white-space: nowrap;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .home-projects-card > .projects-data-box-outer > .profile-box > .profile-image {
    height: 40px;
    width: 40px;
    border-radius: 1000px;
  }


/* overlay box with position-relative to dsplay close button on top right with position-absolute */
.modal-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.modal-box > .close-button {
  position: absolute;
  top: -15px;
  right: -15px;
  background-color: #d2691e;

  height: 30px;
  width: 30px;
  border: none;
  border-radius: 1000px;
}
</style>